import { render, staticRenderFns } from "./TiersTable.vue?vue&type=template&id=8f3e8016&scoped=true&"
import script from "./TiersTable.vue?vue&type=script&lang=js&"
export * from "./TiersTable.vue?vue&type=script&lang=js&"
import style0 from "./TiersTable.vue?vue&type=style&index=0&id=8f3e8016&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3e8016",
  null
  
)

export default component.exports